import React from 'react';
import { SharedLineChart } from '../../charts/SharedLineChart';
import { reportRowsToChartData } from '../../charts/chartAdapters';

export function LineChartBlock({ data }) {
    const rows = data?.rows || [];

    if (rows.length === 0) {
        return <p className="no-data">Sin datos para mostrar</p>;
    }

    const chartData = reportRowsToChartData(rows);

    return (
        <div className="line-chart-block">
            <SharedLineChart chartData={chartData} height={300} />
        </div>
    );
}
